import ADIColors from "@NA/Utils/ADIColors";
import { setPLPUrl } from "@NA/Utils/Utility";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context.session.isAuthenticated,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    middleColumnGridItem?: GridItemProps;
    middleDesktopWrapper?: InjectableCss;
    leftColumnInnerContainer?: GridContainerProps;
    topGridItem?: GridItemProps;
    middleGridItem?: GridItemProps;
    bottomGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    beforeLoginRightBox?: InjectableCss;
    rightBox?: InjectableCss;
    outsideBox?: InjectableCss;
    rightMobileWrapper?: InjectableCss;
    outsideBoxmobilesection?: InjectableCss;
    rightMobileWrappemobilesection?: InjectableCss;
    mobilecentersectionheading?: InjectableCss;
    keyFeaturesContainer?: InjectableCss;
    leftsectionmobile?: InjectableCss;
}

export const viewStyles: ProductDetailsViewStyles = {
    container: {
        css: css`
            ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, null, null, null,
                    css` max-width: 1440px !important;`,],"min",);
            }}
            > div[class^="GridOffset"] {
                @media all and (min-width: 1200px) {
                    justify-content: space-between;
                    flex-wrap: nowrap;
                }
            }
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            overflow: visible;
            z-index: 1;
            position: relative;
            @media all and (min-width: 1200px) {
                max-width: 378px;
                min-width: 378px;
                width: 100%;
            }
            @media all and (min-width: 768px) and (max-width: 1080px) {
                padding-left: 25px;
                padding-right: 25px;
            }
        `,
    },
    leftsectionmobile: {
        css: css`
            display: none;
            @media all and (max-width: 768px) {
                display: block;
                div:nth-child(2) {
                    display: none;
                }
            }
        `,
    },
    topGridItem: { width: 12 },
    middleColumnGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            overflow: hidden;
            @media all and (min-width: 1200px) {
                max-width: 712px;
                width: 100%;
                flex: 100%;
                padding: 15px 15px 15px 23px;
            }
           @media all and (max-width: 768px) {
                order: 2;
            }
        `,
    },
    outsideBoxmobilesection: {
        css: css`
            display: none;
            @media all and (max-width: 768px) {
                display: block;
                padding-left: 15px;
            }
            ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, null, css` margin-bottom: 20px `,],"max",);
            }}
        `,
    },
    outsideBox: {
        css: css`
            @media all and (max-width: 768px) {
                display: none;
            }
        `,
    },

    rightMobileWrappemobilesection: {
        css: css`
            display: none;

            @media all and (max-width: 768px) {
                display: block;
                max-width: 100%;
                flex-basis: 100%;
                padding-left: 15px;
                padding-right: 15px;
            }
        `,
    },
    middleGridItem: {
        width: [12, 12, 12, 6, 6] ,
        css: css`
        padding-top: 0px;
        padding-bottom: 0px;
    `,
    },
    middleDesktopWrapper: {
        css: css`
            width: 100%;
            ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, css` padding-right: 15px; `,],);
            }}
        `,
    },
    bottomGridItem: { width: 12 },
    rightColumnGridItem: {
        width: [12, 12, 12, 3, 3],
        css: css`
            flex-direction: column;
            padding-left: 30px;
            @media all and (min-width: 1200px) {
                max-width: 378px;
                min-width: 378px;
                width: 100%;
            }
            @media all and (max-width: 768px) {
                order: 1;
                padding-left: 15px;
            }
            @media all and (min-width: 767px) and (max-width: 1080px) {
                padding-left: 25px;
                padding-right: 25px;
            }
        `,
    },
    beforeLoginRightBox: {
        css: css`
       padding: 15px 15px 0px;
        width: 100%;
        border-radius: 4px;
        border: solid 1px ${ADIColors.gray2};
        margin-bottom: 12px;
    `,
    },
    rightBox: {
        css: css`
            padding: 15px 15px;
            width: 100%;
            border-radius: 4px;
            border: solid 1px ${ADIColors.gray2};
            margin-bottom: 12px;
            [data-selector="estimationWrapper"]:last-child {
                margin-top: 20px;
                margin-bottom: 0px;
                padding-bottom: 0px;
                border-bottom: none;
            }
            [data-selector="estimationWrapper"] + div[class^="sc"] [data-selector="pdpBanner"] > [data-selector="pdpSlideBanner"] {
                margin-top: 5px;
            }
            .pdpAddToCartBtnWrapper {
                ${({ theme }) => { return breakpointMediaQueries(
                    theme, [null, null, css` max-width: 50%; `,],);
            }}
                > div {
                    > div {
                        &:first-child {
                            flex-basis: 28%;
                            max-width: 28%;
                        }
                        &:last-child {
                            flex-basis: 72%;
                            max-width: 72%;
                        }
                    }
                }
            } 
        `,
    },
    rightMobileWrapper: {
        css: css`
            width: 100%;
            margin-top: 20px;
              @media all and (max-width: 768px) {
                display: none;
            }
        `,
    },
    mobilecentersectionheading: {
        css: css`
            padding-bottom: 0px;
            @media all and (max-width: 768px) {
                display: block;
                div div[class^="GridWrapper"] {
                display:none;
                }
            }
        `,
    },
    keyFeaturesContainer: {
        css: css`
            padding-top: 13px;
        `,
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<Props> = ({ isAuthenticated, ...props }) => {
    React.useEffect(() => {
        setPLPUrl(window.location.pathname)
    }, [])
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumnGridItem} data-test-selector="productDetails_leftColumn">
                <GridContainer {...styles.leftColumnInnerContainer}>
                    <GridItem {...styles.topGridItem}>
                        <Zone contentId={props.id} zoneName="Content0" />
                    </GridItem>
                    <GridItem {...styles.middleGridItem}>
                        <Zone contentId={props.id} zoneName="Content1" />
                    </GridItem>
                    <GridItem {...styles.bottomGridItem}>
                        <Zone contentId={props.id} zoneName="Content2" />
                    </GridItem>
                    <GridItem width={12} {...styles.leftsectionmobile}>
                        <Zone contentId={props.id} zoneName="Content4" />
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.middleColumnGridItem} data-test-selector="productDetails_middleColumn">
                <GridContainer>
                    <GridItem width={12} {...styles.mobilecentersectionheading}>
                        <Zone contentId={props.id} zoneName="Content4" />
                    </GridItem>
                    <GridItem width={[0, 0, 0, 12, 12]} {...styles.keyFeaturesContainer}>
                        <Hidden {...styles.middleDesktopWrapper} below="lg">
                            <Zone contentId={props.id} zoneName="Content6" />
                        </Hidden>
                    </GridItem>
                    <Hidden {...styles.rightMobileWrappemobilesection} above="md">
                        <Zone contentId={props.id} zoneName="Content6" />
                    </Hidden>
                    <StyledWrapper {...styles.outsideBoxmobilesection}>
                        <Zone contentId={props.id} zoneName="Content5" />
                    </StyledWrapper>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.rightColumnGridItem} data-test-selector="productDetails_rightColumn">
                <StyledWrapper {...(isAuthenticated ? styles.rightBox : styles.beforeLoginRightBox)}>
                    <Zone contentId={props.id} zoneName="Content3" />
                </StyledWrapper>

                <Hidden {...styles.rightMobileWrapper} above="md">
                    <Zone contentId={props.id} zoneName="Content6" />
                </Hidden>
                <StyledWrapper {...styles.outsideBox}>
                    <Zone contentId={props.id} zoneName="Content5" />
                </StyledWrapper>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
